import Toast from '../../components/toast';
import './index.less';

export function init(params: {
    error: string
}) {
    if (params.error)
        Toast.error(params.error);
}
